<template>
    <div class="py-8 text-center">
        <div v-if="!error">
            <svg class="animate-spin h-8 w-8 mx-auto text-blue-900" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p class="text-sm text-gray-600 mt-4">
                {{ $t('Signing you in, please wait...') }}
            </p>
        </div>
        <div v-else>
            <p class="text-sm text-red-600 mb-4">
                {{ error }}
            </p>
            <router-link
                to="/auth/login"
                class="text-sm text-[#E63946] hover:text-[#C62828] font-medium transition"
            >
                {{ $t('Back to login') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    name: "sso",
    data() {
        return {
            error: null
        }
    },
    mounted() {
        this.exchange();
    },
    methods: {
        exchange() {
            const self = this;
            const ticket = self.$route.query.ticket;

            if (!ticket) {
                self.fail(self.$i18n.t('The SSO ticket is invalid or has expired, try logging in again from GCC').toString());
                return;
            }

            axios.post('api/auth/sso-exchange', {ticket: ticket}).then(function (response) {
                self.$store.commit('login', response.data);
                const intendedUrl = Cookies.get('intended_url');
                const permissions = (response.data.user && response.data.user.role && response.data.user.role.permissions) ? response.data.user.role.permissions : {};
                const hasTicketAccess = !!permissions['App.Http.Controllers.Api.Dashboard.TicketController'];
                const hasStatsAccess = !!permissions['App.Http.Controllers.Api.Dashboard.StatsController'];
                const defaultRoute = hasTicketAccess ? '/dashboard/tickets' : (hasStatsAccess ? '/dashboard/home' : '/account');

                if (intendedUrl) {
                    Cookies.remove('intended_url');
                    self.$router.push(intendedUrl);
                } else {
                    self.$router.push(defaultRoute);
                }
            }).catch(function (error) {
                const message = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : self.$i18n.t('The SSO ticket is invalid or has expired, try logging in again from GCC').toString();
                self.fail(message);
            });
        },
        fail(message) {
            this.error = message;
            const params = {...this.$route.query};
            delete params.ticket;
            this.$router.replace({query: params}).catch(function () {
            });
        }
    }
}
</script>
